import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import SettingsDetail from './SettingsDetail';
import { Loading } from '../../components/Loading';
import { growlErrors } from '../../utils/NotificationUtil';
import { AccountContext } from '../../components/AccountContext';
import { NotificationContext } from '../../components/GrowlNotifications';

export const ACCOUNT_SETTINGS_QUERY = gql`
  query currentAccountSettings($accountId: ID!) {
    account(id: $accountId) {
      id
      type
      isHeadOfFamily
      respondentData {
          internalRespondents {
            includedInPlan
            presentlyUsed
            deletionRule {
              type
              numberOfDaysToAnonymizeAfter
            }
          }
          externalRespondents {
            includedInPlan
            presentlyUsed
            deletionRule {
              type
              numberOfDaysToAnonymizeAfter
            }
          }
      }
      gpiRepresentativeData {
        parentAccountOwnerFullName
        parentAccountOwnerEmail
      }
      companyInformation {
        name
        displayName
        addressLine1
        addressLine2
        city
        state
        country
        postalCode
        taxData {
          id
          type
          country
          description
          taxId
        }
        totalNumberEmployees
        registrationNumber
        dpoEmail
        creditNotificationThreshold
      }
      currentCreditPlan
      brandingInformation {
        primaryColor
        logo {
          width
          height
        }
        website
        socialMediaLinks {
          name
          url
        }
      }
    }
  }
`;

const SettingsDetailComponent = ({ scopes, viewerRole }) => {
  const accountId = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  return (
    <Query query={ACCOUNT_SETTINGS_QUERY} variables={{ accountId }}>
      {({ loading, error, data }) => {
        if (loading) {
          return <Loading />;
        }
        if (error) {
          growlErrors(growl, error);
        }

        const { account } = data;

        return <SettingsDetail account={account} viewerRole={viewerRole} scopes={scopes} />;
      }}
    </Query>
  );
};

SettingsDetailComponent.propTypes = {
  scopes: PropTypes.arrayOf(PropTypes.any).isRequired,
  viewerRole: PropTypes.string.isRequired,
};

export default SettingsDetailComponent;
